// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1WmCX","inputDescription":"styles_inputDescription__1UAOM"};